module.exports = __webpack_public_path__ + "img/Truppführer_Öl.f34e4df3.svg";